import { Box, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Paper, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAGrid from "../config/components/BAGrid";
import { useEffect, useState } from "react";
import BAModal from "../config/components/BAModal";
import BAInput from "../config/components/BAInput";
import { Delete, Get, Post, Put } from "../config/apimethods/apimethods";
import BAIconbutton from "../config/components/BAIconbutton";
import AddIcon from '@mui/icons-material/Add';
import BAButton from "../config/components/BAButton";
import BAShowError from "../config/components/BAShowerror";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


export default function Settings() {
    const [settingOption, setSettingOption] = useState('')
    return <>
        <Box>
            <BAScreenHeader title='Settings' />
            <Box className="bg-white">
                <Grid container>
                    <Grid item md={3}>
                        <Box className="p-2">
                            <List>
                                <ListItemButton onClick={() => setSettingOption('category')} selected={settingOption == "category"}>
                                    <ListItemText primary="Categories" />
                                </ListItemButton>
                                <Divider />
                                <ListItemButton onClick={() => setSettingOption('user')} selected={settingOption == "user"}>
                                    <ListItemText primary="User" />
                                </ListItemButton>
                                <ListItemButton onClick={() => setSettingOption('settings')} selected={settingOption == "settings"}>
                                    <ListItemText primary="Settings" />
                                </ListItemButton>
                                <Divider />

                            </List>
                        </Box>
                    </Grid>
                    <Grid item md={9}>
                        <Paper className="p-2 settingBody">
                            {settingOption == "category" && <CategoryComponent />}
                            {settingOption == "user" && <UserComponent />}
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    </>
}

function CategoryComponent() {
    const [categoryList, setCategoryList] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [model, setModel] = useState({})
    const [saveLoader, setSaveLoader] = useState(false)
    const [loader, setLoader] = useState(false)
    const [message, setMessage] = useState()
    const [showMessage, setShowMessae] = useState(false)


    let getCategories = () => {
        setLoader(true)
        Get('category').then(res => {
            setLoader(false)
            setCategoryList([...res.data])
        }).catch(err => {
            setLoader(false)
        })
    }

    let save = () => {
        setSaveLoader(true)
        if (model._id) {
            Put('category', model, model._id).then(res => {
                setSaveLoader(false)
                getCategories()
                setOpenModal(false)
                setMessage("Category Added Successfully")
                setShowMessae(true)
                setModel({})
            }).catch(err => {
                setSaveLoader(false)
                setMessage(err.message)
                setShowMessae(true)
            })
        } else {
            Post('category', model).then(res => {
                setSaveLoader(false)
                getCategories()
                setOpenModal(false)
                setMessage("Category Added Successfully")
                setShowMessae(true)
                setModel({})
            }).catch(err => {
                setSaveLoader(false)
                setMessage(err.message)
                setShowMessae(true)
            })
        }
    }

    let deleteCat = (id) => {
        Delete('category', id).then(res => {
            getCategories()
            setMessage("Category Deleted Successfully")
            setShowMessae(true)
        }).catch(err => {
            setMessage(err.message)
            setShowMessae(true)
        })
    }

    let editCat = (e) => {
        setModel({ ...e })
        setOpenModal(true)
    }

    useEffect(() => {
        getCategories()
    }, [])

    return <>
        <BAShowError open={showMessage} close={(e) => setShowMessae(e)} message={message} />
        <BAModal modalTitle='Add Category' width='40vw' open={openModal} close={(e) => {
            setModel({})
            setOpenModal(e)
        }} innerContent={<Box className="p-2">
            <Box className="py-2">
                <BAInput value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} label='Category Name' />
            </Box>
            <Box className="py-2">
                <BAInput value={model.unit} onChange={(e) => setModel({ ...model, unit: e.target.value })} label='Category Unit' />
            </Box>
        </Box>} modalFooter={<Box className="text-center">
            <BAButton loading={saveLoader} onClick={save} label='Save' />
        </Box>} />
        <Box>
            <Box className="d-flex justify-content-between align-items-center p-2">
                <Typography variant="h5">Category</Typography>
                <BAIconbutton onClick={() => setOpenModal(true)} icon={<AddIcon />} />
            </Box>
            <BAGrid loading={loader} gridCols={[
                {
                    label: 'Delete',
                    key: 'del',
                    className: 'btnCell',
                    displayField: (e) => <BAIconbutton onClick={() => deleteCat(e._id)} icon={<DeleteIcon />} />
                },
                {
                    label: 'Edit',
                    key: 'edit',
                    className: 'btnCell',
                    displayField: (e) => <BAIconbutton onClick={() => editCat(e)} icon={<EditIcon />} />
                },
                {
                    label: 'Name',
                    key: 'name'
                },
                {
                    label: 'Unit',
                    key: 'unit'
                },
            ]} datasource={categoryList} />

        </Box>
    </>
}

function UserComponent() {

    const [listData, setListData] = useState([])
    const [message, setMessage] = useState()
    const [showMessage, setShowMessage] = useState(false)
    const [loader, setLoader] = useState(false)
    const [saveLoader, setSaveLoader] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [model, setModel] = useState({})

    let getUser = () => {
        setLoader(true)
        Get('/api/user').then(res => {
            setLoader(false)
            setListData([...res.data])
        }).catch(err => {
            setLoader(false)
            setShowMessage(true)
            setMessage(err.message)
        })
    }

    let deleteUser = (id) => {
        Delete('api/user', id).then(res => {
            getUser()
            setShowMessage(true)
            setMessage('User Deleted Successfully')
        }).catch(err => {
            setShowMessage(true)
            setMessage(err.message)
        })
    }

    let save = () => {
        if (!model.userName || !model.password) {
            setMessage("User Name and Password are Required")
            setShowMessage(true)
            return
        }
        if (model.password != model.confirmPassword) {
            setMessage("Confirm Password is not match")
            setShowMessage(true)
            return
        }
        setSaveLoader(true)
        model.userType = 2
        Post('api/user/signup', model).then(res => {
            setSaveLoader(false)
            setMessage("User Created Successfully")
            setShowMessage(true)
            setOpenModal(false)
            setModel({})
            getUser()
        }).catch(err => {
            setSaveLoader(false)
            setMessage(err.response?.data?.errors)
            setShowMessage(true)
        })
    }

    useEffect(() => {
        getUser()
    }, [])

    return <>
        <BAShowError message={message} open={showMessage} close={(e) => setShowMessage(e)} />
        <BAModal open={openModal} close={(e) => {
            setModel({})
            setOpenModal(e)
        }} modalTitle='Add User' innerContent={<Box>
            <Box className="py-1">
                <BAInput value={model.userName} onChange={(e) => setModel({ ...model, userName: e.target.value })} label="User Name" />
            </Box>
            <Box className="py-1">
                <BAInput type='password' value={model.password} onChange={(e) => setModel({ ...model, password: e.target.value })} label="Password" />
            </Box>
            <Box className="py-1">
                <BAInput type='password' value={model.confirmPassword} onChange={(e) => setModel({ ...model, confirmPassword: e.target.value })} label="Confirm Password" />
            </Box>
        </Box>} modalFooter={<Box className="text-center">
            <BAButton loading={saveLoader} onClick={save} label='Save' />
        </Box>} width="30vw" />
        <Box>
            <Box className="p-2 d-flex justify-content-between">
                <Typography variant="h5">Users</Typography>
                <BAIconbutton onClick={() => setOpenModal(true)} icon={<AddIcon />} />
            </Box>

            <Box>
                <BAGrid loading={loader} datasource={listData} gridCols={[
                    {
                        key: 'delete',
                        label: 'Delete',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => deleteUser(e._id)} icon={<DeleteIcon />} />
                    },
                    {
                        key: 'userName',
                        label: 'User Name'
                    }
                ]} />
            </Box>
        </Box>
    </>
}